module.exports = __webpack_public_path__ + "static/media/room-15.6032eb81.jpg";